import React from "react";

import { StarRating } from "../shared/star-rating.jsx";
import { TrophyRating } from "../shared/trophy-rating.jsx";
import { Provider } from "react-redux";
import gommeStore from "../../stores/gomme-store.js";

import { Web } from "../shared/web.js";
import { Localize } from "../shared/localize.js";

import { AddToCartButton } from "../cart/add-to-cart-button.jsx";

class Wheel extends React.Component {
  constructor(props) {
    super(props);

    this.priceRef = React.createRef();
    this.diamRef = React.createRef();

    //this.state = {
    //  localSelectedDiameter: this.props.wheelDetails.selectedDiameter,
    //  changed: 0
    //};
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.wheelDetails.DetailsUrl == "https://localhost:44354/cerchi-in-ferro/volkswagen/golf/2017?diameter=17&wheelbrand=kfz+alcar&wheelmodel=hybridrad&wheelholes=5&wheelcolor=nero") {
      console.log("prevState", prevState);
      console.log("actualState", this.state);
    }
  }

  handleClick = (e, diameter) => {
    window.setTimeout(() => {
      this.priceRef.current.style.animation = "0.5s flipOutY ease";
      this.diamRef.current.style.animation = "0.5s flipOutY ease";
      window.setTimeout(() => {
        this.props.localWheelSelectDiameter(this.props.wheelDetails, diameter);
        //this.setState({ localSelectedDiameter: diameter, changed: ++this.state.changed });

        this.priceRef.current.style.animation = "0.5s flipInY ease";
        this.diamRef.current.style.animation = "0.5s flipInY ease";
        window.setTimeout(() => {
          this.priceRef.current.style.animation = "none";
          this.diamRef.current.style.animation = "none";
        }, 500);
      }, 500);
    }, 0);
  }

  promoCheck(details, conditions) {
    return conditions.find(item => {
      if (item.conditions == null) {
        return true;
      }

      for (var ii = 0; ii < item.conditions.length; ii++) {
        var condition = item.conditions[ii];

        if (condition != null) {
          if ((((condition.brand || "") != "") && (condition.brand.toUpperCase() == details.Brand.toUpperCase()) && ((condition.model || "") != "") && (condition.model == details.Model.toUpperCase()))
            || (((condition.brand || "") != "") && (condition.brand.toUpperCase() == details.Brand.toUpperCase()) && ((condition.model || "") == ""))
            || (((condition.model || "") != "") && (condition.model.toUpperCase() == details.Model.toUpperCase()) && ((condition.model || "") != ""))) {
            return true;
          }
        }
      }

      return false;
    });
  }

  render() {

    var ret = null;

    if (this.props.wheelDetails.DetailsUrl == "https://localhost:44354/cerchi-in-ferro/volkswagen/golf/2017?diameter=17&wheelbrand=kfz+alcar&wheelmodel=hybridrad&wheelholes=5&wheelcolor=nero") {
      console.log("actualState render", this.state);
    }

    var details = this.props.wheelDetails;
    if (details) {
      var diameters = details.Diameters.filter((d) => this.props.filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active));
      var selectedDiameter = details.selectedDiameter;

      var realSelectedWheel = this.props.wheelDetails.Diameters.find(d => d.Diameter == selectedDiameter);
      //following code should be revised to use realSelectedWheel

      var bestPrice = null;

      if (diameters) {
        bestPrice = diameters.filter(d => d.Diameter == selectedDiameter)[0].BestPrice;
        bestPrice = (
          <div ref={this.priceRef}><span className={"price " + ("price-diameter-" + selectedDiameter)}> {bestPrice.toFixed(2)} &euro; </span></div>
        );

        var buttons = [];
        diameters.forEach((d, i) => {
          buttons.push((
            <button key={"btn-diameter" + i}
              type="button" className={"btn btn-secondary " + (d.Diameter == selectedDiameter ? " active" : "")}
              onClick={(e) => this.handleClick(e, d.Diameter)}
            >
              {d.Diameter}
            </button>
          ));
        });
      }

      var fastshipping = null;
      if (realSelectedWheel && realSelectedWheel.DaysToDeliver) {
        if (realSelectedWheel.DaysToDeliver <= 1) {
          fastshipping = <div className="fastshipping">{Localize.L("Consegna").toUpperCase()}
            <span className="fa-2x fa-layers fa-fw" style={{ verticalAlign: "middle" }}>
              <i className="far fa-circle"></i>
              <span className="fa-layers-text" data-fa-transform="shrink-8 down-0" style={{ fontWeight: 900 }}>24</span>
            </span>
            {Localize.L("ore")}
          </div>;
        }
        else if (realSelectedWheel.DaysToDeliver <= 5) {
          fastshipping = <div className="fastshipping" style={{ backgroundColor: "#dddddd", color: "#444" }}>{Localize.L("Consegna {days} gg").replace("{days}", realSelectedWheel.DaysToDeliver).toUpperCase()}</div>;
        }
      }

      var DetailsUrl = details.DetailsUrl.replace(/(diameter=)[^\&]+/, '$1' + selectedDiameter).replace("[\d]+" + Localize.L("-pollici"), selectedDiameter + Localize.L("-pollici"));

      var cssCol = "col-sm-6 col-md-4 col-lg-3";
      switch (this.props.howManyColumns) {
        case 2:
          cssCol = "col-sm-6";
          break;
        case 3:
          cssCol = "col-sm-6 col-md-4";
          break;
        case 4:
          cssCol = "col-sm-6 col-md-4 col-lg-3";
          break;
      }

      var delayOffset = -12;
      var diameterOffset = 20;

      /////////////////////// TODO

      var promo = (window.WheelTitles != null) ? this.promoCheck(details, window.WheelTitles) : null;

      var promo_title = null;

      if (promo != null) {
        delayOffset += 50;
        diameterOffset += 55;

        promo_title = (
          <div style={{ backgroundColor: promo.background, fontSize: "16px", fontWeight: 400, padding: "0px 5px 2px 3px", position: "absolute", top: "-5px", zIndex: 10, color: promo.title2Color, borderRadius: "6px 6px 0px 0px", width: "100%", textAlign: "left" }}>
            <div className="text-left" style={{ padding: "3px 6px", fontFamily: "Roboto Condensed", lineHeight: 1.2 }}>
              <span style={{ fontWeight: 700, color: promo.title1Color }}>{promo.title1}</span><br />{promo.title2}
            </div>
          </div>
        );
      }

      var specialLabel = null;

      if ((details.SpecialLabel || "") != "") {
        diameterOffset += 30;

        specialLabel = (
          <div className="product-data" style={{ "borderRadius": "3px", "position": "absolute", "top": (delayOffset + 35) + "px", "left": "-10px", "zIndex": "20" }}>
            <div className="fastshipping" style={{ "backgroundColor": "rgb(221, 221, 221)", "color": "rgb(68, 68, 68)", "textTransform": "uppercase" }}>
              {details.SpecialLabel}
            </div>
          </div>
        );
      }

      const { Car, ...wheelresult } = { ...details, Diameter: selectedDiameter }; 

      ret = (
        <div className={cssCol}>
          <div className="products-listitem wheel mb-3">
            {promo_title}
            <div className="product-data" style={{ borderRadius: 3, position: "absolute", zIndex: "20", top: delayOffset + "px", left: -10 }}>
              {fastshipping}
            </div>
            {specialLabel}
            <div className="product-data product-image mb-3">
              <a href={DetailsUrl} title={details.Model + " " + details.Color + " " + details.Holes + " " + Localize.L("fori") + (this.props.car != null ? " per " + this.props.car.ManufacturerName + " " + this.props.car.ModelName + " " + this.props.year : "")}>
                <img className="img-fluid" alt={details.Model + " " + details.Color + " " + details.Holes + " " + Localize.L("fori") + (this.props.car != null ? " per " + this.props.car.ManufacturerName + " " + this.props.car.ModelName + " " + this.props.year : "")} src={details.MediumImgUrl} />
              </a>
            </div>
            <div className="text-right product-diameter-label" style={{ top: diameterOffset + "px" }}>
              <div className="btn-group btn-group-lg" role="group" aria-label="First group">
                {buttons}
              </div>
            </div>
            <div className="product-data product-brand mb-3">
              <img className="img-fluid mx-auto d-block" alt={details.Brand} src={Web.W("wheel_image_map") + "brands/o/" + details.Brand + ".jpg"} />
            </div>
            <div className="product-data product-description mb-3">
              <a href={DetailsUrl} title="">
                {details.Model}
                <br />
                {details.Color} {details.Holes} {Localize.L("fori")}
                <br />
                {Localize.L("Diametro")} <span ref={this.diamRef} style={{ fontWeight: 700 }}>{selectedDiameter}"</span>
              </a>
            </div>
            <div className="product-data product-bottom">
              <div className="product-price mb-2">
                {bestPrice}
              </div>
              <div>
                <a className="btn btn-light btn-big-enough" href={DetailsUrl} title={Localize.L("Caratteristiche") + " " + details.Brand + " " + details.Model}>
                  <span>{Localize.L("Vedi dettagli")}</span>
                </a>
                &nbsp;
                <Provider store={gommeStore}>
                  <AddToCartButton
                    wheelresult={wheelresult}
                    text={Localize.L("Acquista")} style={"btn-big-enough"}
                    target={"wheel"}
                    car={details.Car ? {
                      ManufacturerName: details.Car.ManufacturerName,
                      ModelName: details.Car.ModelName,
                      ExtChassis: details.Car.ExtChassis ? details.Car.ExtChassis != details.Car.ModelName ? details.Car.ExtChassis : "" : null,
                      ExtModelType: details.Car.ExtModelType
                    } : this.props.car}
                    year={this.props.year}
                  />
                </Provider>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return ret;
  }

}

export { Wheel };